<template>
  <el-main style="background: #fff">
    <div class="mainbody">
      <!-- <h3 class="title">{{ headTitle }}</h3> -->
      <div class="tableInfo">
        <el-form
          v-model="waitReviewInfo"
          :inline="true"
          :label-position="labelPosition"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item label="企业名称" class="test">
                <!-- <el-input v-model="formLabelAlign.name"></el-input> -->
                <div>{{ waitReviewInfo.title }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="地址" class="test">
                <!-- <el-input v-model="formLabelAlign.region"></el-input> -->
                <div>{{ waitReviewInfo.location }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="所在地" class="test">
                <div v-if="waitReviewInfo.province && waitReviewInfo.city">
                  {{ waitReviewInfo.province }} - {{ waitReviewInfo.city }}
                </div>
                <div v-if="waitReviewInfo.province && !waitReviewInfo.city">
                  {{ waitReviewInfo.province }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="营业时间" class="test">
                <div>{{ waitReviewInfo.open_hours }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="联系电话(多个电话请用,分割)"
                class="test"
                size="small"
              >
                <div>{{ waitReviewInfo.mobile }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="人均价格" class="test">
                <div>{{ waitReviewInfo.price }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="分类" class="test">
                <div v-if="typeOptions">{{ typeOptions }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="经纬度" class="test">
                <div>{{ waitReviewInfo.latitudeAndLongitude }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="缩略图">
                <el-image
                  style="width: 100px; height: 100px"
                  :src="waitReviewInfo.thumb"
                ></el-image>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="宣传图">
                <div style="display: flex">
                  <div v-if="waitReviewInfo.shop_image == ''">
                    <el-image
                      style="width: 180px; height: 180px; margin-right: 30px"
                    ></el-image>
                  </div>
                  <div
                    v-else
                    v-for="(imgs, index) in waitReviewInfo.shop_image"
                    :key="index"
                  >
                    <el-image
                      style="width: 180px; height: 180px; margin-right: 30px"
                      :src="imgs.link"
                      fit="fill"
                      :preview-src-list="[imgs.link]"
                    >
                    </el-image>
                  </div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="企业详情">
                <div style="margin-bottom: 15px">
                  {{ waitReviewInfo.rich_text }}
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
  </el-main>
</template>

<script>
import { URL_PATH } from "@/config/config";
export default {
  data() {
    return {
      urlPath: URL_PATH,
      labelPosition: "top",
      waitReviewInfo: {},
      activeName: "1",
      typeOptions: [],
      latitudeAndLongitude: "",
    };
  },
  created() {
    this.getWaitReviewShopInfo();
  },
  methods: {
    getWaitReviewShopInfo() {
      var id = this.$route.query.id;
      this.$api
        .waitReviewShopInfo({
          token: localStorage.getItem("token"),
          shop_log_id: id,
        })
        .then(({ data }) => {
          this.waitReviewInfo = data.Data;
          this.shopTypeTreeList();
          if (data.Data.latitude && data.Data.longitude) {
            this.$set(
              this.waitReviewInfo,
              "latitudeAndLongitude",
              data.Data.latitude + "," + data.Data.longitude
            );
          }
        })
        .catch(({ error }) => {});
    },
    // 获取类型
    shopTypeTreeList() {
      var ids = this.waitReviewInfo.type_id;
      this.$api
        .shopTypeTreeList()
        .then(({ data }) => {
          data.Data.forEach((info) => {
            if (this.waitReviewInfo.type_id == info.id) {
              this.typeOptions = info.title;
            }
            if (info.son) {
              info.son.forEach((son) => {
                if (this.waitReviewInfo.type_id == son.id) {
                  this.typeOptions = info.title + "/" + son.title;
                }
              });
            }
          });
        })
        .catch(({ error }) => {});
    },
  },
};
</script>

<style lang="less" scoped>
.test {
  width: 295px;
  height: 100px;
}
.mainbody {
  background: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/enterprise/enterpriseReviewDetail.vue